// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CategoryFormController from "./category_form_controller"
application.register("category-form", CategoryFormController)

import CurrencySelectorController from "./currency_selector_controller"
application.register("currency-selector", CurrencySelectorController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import RequestTypeController from "./request_type_controller"
application.register("request-type", RequestTypeController)

import TagFormController from "./tag_form_controller"
application.register("tag-form", TagFormController)

import TaxCalculatorController from "./tax_calculator_controller"
application.register("tax-calculator", TaxCalculatorController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
